import { Component, Host, h, Prop } from '@stencil/core';

@Component({
    tag: 'sew-ws-lightbox',
    shadow: false,
})
export class SewWsLightbox {
    @Prop() triggerSelector = '.sew-ws-lightbox-trigger';
    @Prop() contentSrc = 'data-url';

    private dialogElement: HTMLSewDialogElement;
    private dialogContentElement: HTMLDivElement;

    componentWillLoad() {
        const triggerElements = document.querySelectorAll(this.triggerSelector);

        triggerElements.forEach(el => {
            el.addEventListener('click', this.openDialog);
        });
    }

    private openDialog = (event: Event) => {
        const button = event.target as HTMLDivElement;
        const url = button.getAttribute(this.contentSrc);

        // early exit if there is no contentSrc
        if (!url) {
            this.dialogElement.open = true;

            return;
        }

        const loaded = button.getAttribute('loaded');

        if (loaded) {
            this.dialogElement.open = true;
        } else {
            button.setAttribute('loaded', 'true');
            this.getSrcContent(url);
        }
    };

    private getSrcContent(url): void {
        fetch(url)
            .then(response => response.text())
            .then(html => {
                this.dialogContentElement.append(document.createRange().createContextualFragment(html));
                this.dialogElement.open = true;
            })
            .catch(e => {
                console.error(e);
            });
    }

    render() {
        return (
            <Host>
                <sew-dialog
                    ws
                    type={'blank'}
                    close-button={true}
                    size={'l'}
                    ref={el => (this.dialogElement = el)}
                >
                    <div ref={el => (this.dialogContentElement = el)}></div>
                    <slot></slot>
                </sew-dialog>
            </Host>
        );
    }
}
